import { ApiKeyMessage } from '../../../../../types/ApiKeyMessage';
import { Characters } from '../../../../common/helpers/unicode.helper';

export const truncateApiKey = (key: ApiKeyMessage['key']) => {
    return `${key.slice(0, 3)}${Characters.HORIZONTAL_ELLIPSIS}${key.slice(-3)}`;
};
